//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Pivot from "vue-flexmonster";
// import "flexmonster/flexmonster.css";
import "@/styles/flexmonster.min.css"
import FlexmonsterHandlers from "@/pages/MyPivot/components/customHandlers/flexmonsterHandlers.js";

export default {
  name: "PivotTable",
  components: {
    Pivot,
  },
  data: () => ({
    headers: null,
  }),
  props: ["flexmonsterData", "fastDbTables"],
  methods: {
    customizeCellFunction: function (cell, data) {
      let repeatValues = localStorage.getItem('repeatExpandedValues')
      if (repeatValues != null && !!repeatValues) {
        if (data.member != null && data.label == '') {
          if (!data.member.uniqueName.includes('(all member)')) {
            cell.text = data.member.caption
          }
        }
        //column repeat expanded header values (special case)
        if (data.type == 'header' && data.member == null && data.hierarchy == null && data.measure == null && data.label == '') {
          let searchingHeader = true;
          let currentColIndex = data.columnIndex - 1;
          while (searchingHeader) {
            let neighborCell = window.flexmonster.getCell(data.rowIndex, currentColIndex);
            if (neighborCell.label == '') {
              if (currentColIndex == 0) {
                searchingHeader = false;
              }
              currentColIndex -= 1;
            } else {
              cell.text = neighborCell.label;
              searchingHeader = false;
            }
          }
        }
      }
    },
    customizeToolbar: function (toolbar) {
      toolbar.showShareReportTab = false;
      // get all tabs
      let tabs = toolbar.getTabs();
      toolbar.getTabs = function () {
        // remove the Connect tab using its id
        tabs = tabs.filter((tab) => tab.id != "fm-tab-connect");
        tabs = tabs.filter((tab) => tab.id != "fm-tab-save");
        tabs = tabs.filter((tab) => tab.id != "fm-tab-open");
        tabs
          .find((e) => e.id === "fm-tab-export")
          .menu.find((e) => e.id === "fm-tab-export-excel").handler = function (
            a
          ) {
            if (a === "pdf") {
              this.showExportPdfDialog();
            } else {
              if (a === "excel") {
                var params = {
                  filename: "pivot",
                  excelSheetName: "pivot",
                };

                this.pivot.exportTo("excel", params);
              } else {
                this.pivot.exportTo(a);
              }
            }
          };
        FlexmonsterHandlers.optionsDialogHandler(toolbar);
        return tabs;
      };
    },
    onReady: function () { },
    convertType: function (type, related_pg_table, related_pg_col) {
      if (related_pg_table === "hierarchy_levels") {
        return "string";
      }

      //Data - Ano e Data - Mês
      if (
        related_pg_table === "sellout_indicators" &&
        (related_pg_col === "file_upload_id") &&
        type === "int"
      ) {
        return "string";
      }

      switch (type) {
        case "date":
          return "date string";
        case "int":
          return "number";
        case "float":
          return "number";
        case "double":
          return "number";
        default:
          return "string";
      }
    },
    getSliceObj: function () {
      let slice = {
        rows: [],
        measures: [],
        flatOrder: [],
      };
      let selectedData = this.flexmonsterData[0];
      for (let i = 0; i < selectedData.length; i++) {
        let type = this.headers[selectedData[i]].type;
        if (type === "string" || type === "date string") {
          slice.rows.push({
            uniqueName: selectedData[i],
          });
        } else if (['Data - Ano', 'Data - Mês', 'Data - Dia'].includes(selectedData[i])) {
          slice.rows.push({
            uniqueName: selectedData[i],
          });
        } else {
          slice.measures.push({
            uniqueName: selectedData[i],
          });
        }
        slice.flatOrder.push(selectedData[i]);
      }
      return slice;
    },
  },
  mounted() {
    let object = {};
    Object.keys(this.fastDbTables["sellout_data"]).forEach((key) => {
      object[this.fastDbTables["sellout_data"][key].label] = {
        type: this.convertType(
          this.fastDbTables["sellout_data"][key].type,
          this.fastDbTables["sellout_data"][key].related_pg_table,
          this.fastDbTables["sellout_data"][key].related_pg_column
        ),
      };
    });
    this.headers = object;
    if (this.$refs.pivot) {
      var report = {
        options: {
          grid: {
            type: "classic",
            showGrandTotals: "off",
            showTotals: "off",
          },
        }
      }
      this.$refs.pivot.flexmonster.setReport(report);
    }
  },
  watch: {
    flexmonsterData: {
      // immediate: true,
      deep: true,
      handler: function () {
        let slice = this.getSliceObj();
        if (this.$refs.pivot) {
          var report = {
            dataSource: {
              data: this.flexmonsterData,
              mapping: this.headers,
            },
            slice: slice,
            options: {
              grid: {
                type: this.$refs.pivot.flexmonster.getOptions().grid.type,
                showGrandTotals: "off",
                showTotals: "off",
              },
              defaultDateType: "EAN string",
            },
            localization: {
              grid: {
                blankMember: "",
              },
            },
          };
          var format = {
            name: "",
            maxDecimalPlaces: 2
          }
          this.$refs.pivot.flexmonster.setReport(report);
          this.$refs.pivot.flexmonster.setFormat(format);
          this.$refs.pivot.flexmonster.expandAllData();
        }
      },
    },
  },
  computed: {
    //get flexmosnter key from env
    flexmonsterKey: () => process.env.VUE_APP_FLEXMONSTER_KEY,
  },
};
